import { useState, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// State
import { addToCart, addToCartFromUpsale } from '../../../state/modules/catalog/actions';
import { applyStock, addReward } from '../../../state/modules/stock/actions';

export default function useUpsaleSlider() {
  const dispatch = useDispatch();
  const stockCode = useSelector(state => state.catalog.upsale.stockCode);
  const items = useSelector(state => state.catalog.upsale.items);
  const [isLoading, setIsLoading] = useState([]);

  const handleAddToCart = useCallback(
    async (variation, index) => {
      setIsLoading(prev => [...prev, variation.id]);

      if (stockCode) {
        await dispatch(applyStock({ stock_code: stockCode }));

        const ingredients = variation.include_ingredients || [];

        const filtredIngredients =
          ingredients
            .filter(ingredient => ingredient.removed)
            .map(ingredient => ({ id: ingredient.id, count: 0 })) || [];

        const composition = [{ id: variation.id, ingredients: filtredIngredients }];
        await dispatch(addReward(variation.id, 0, composition, true));
      } else {
        await dispatch(addToCart(variation.id, [{ type: 'good', item: variation }], true));
      }

      setIsLoading(prev => prev.filter(prevId => prevId !== variation.id));
      dispatch(addToCartFromUpsale({ variation, index })); // нужно для аналитики
    },
    [stockCode],
  );

  const variations = useMemo(() => {
    return items?.length > 0
      ? items.map(good => good.variations.map(variation => ({ ...good, ...variation }))).flat()
      : null;
  }, [items]);

  return { isLoading, handleAddToCart, variations };
}
